import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Link } from "@mui/material";

import DigitalLogo from "../../../assets/images/2060Digital-logo.svg";
import { HeaderStyled } from "../styles/Header.style";
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MenuProps } from "@mui/material/Menu";
import { pxtorem } from "../../../assets/styles/theme";

interface HeaderProps {}

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({   
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
     
    boxShadow: 
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "& .MuiMenu-list": {
      padding: "4px 0",
      "li": {
        padding: '2px 12px',
      }      
    },

    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: pxtorem(16),
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
})); 
 
  const Header: React.FC<HeaderProps> = ({}) => {
  const navigate = useNavigate();
  
  const firstName = window.localStorage.getItem('FIRST_NAME');
  const lastName = window.localStorage.getItem('LAST_NAME');
  const userEmail = window.localStorage.getItem('USER_EMAIL');

  const user = `${firstName},${lastName}`
  const userName = firstName && lastName ? user : userEmail;

  const displayName = () => {
    const validFirstName = firstName && firstName !== "null" ? firstName : null;
    const validLastName = lastName && lastName !== "null" ? lastName : null;
    
    if (validFirstName && validLastName) {
      return `${validFirstName} ${validLastName}`;
    } else if (validFirstName) {
      return validFirstName;
    } else if (userEmail) {
      return userEmail.split('@')[0];
    } else {
      return "User";
    }
  };

  const getInitials = () => {
    const validFirstName = firstName && firstName !== "null" ? firstName : null;
    const validLastName = lastName && lastName !== "null" ? lastName : null;
    
    if (validFirstName && validLastName) {
      return `${validFirstName[0]}${validLastName[0]}`;
    } else if (validFirstName) {
      return validFirstName[0];
    } else if (userEmail) {
      return userEmail[0].toUpperCase();
    } else {
      return "U"; // Ultimate fallback
    }
  };
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleUserNameClick = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleUserNameClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <HeaderStyled>
      <div onClick={() => navigate("/clients")}>
        <Link className="logo">
          <img
            src={DigitalLogo}
            alt="2060 Digital Logo"
            style={{ marginTop: "3px" }}
          />
        </Link>
      </div>
      
      <Button variant="contained"  id="demo-customized-button" onClick={handleUserNameClick}>
        {getInitials()}
      </Button>
      
      <StyledMenu
        id="user-full-name"
        MenuListProps={{
          "aria-labelledby": "user fullname menu",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={(event, reason) => {
          // Prevent closing when clicking outside or pressing Escape
          handleUserNameClose(); // Close the menu only when explicitly called
        }}
      >
        <MenuItem 
          onClick={handleUserNameClose} 
          disableRipple> 
          {displayName()}
        </MenuItem>
       
      </StyledMenu>

    </HeaderStyled>
  );
};

export default Header;
